export const mockUsers = [
  {
    id: '1',
    name: 'Aarav Sharma',
    email: 'aarav.sharma@example.com',
    role: 'Admin',
    status: 'Active',
  },
  {
    id: '2',
    name: 'Priya Gupta',
    email: 'priya.gupta@example.com',
    role: 'User',
    status: 'Active',
  },
  {
    id: '3',
    name: 'Kavya Reddy',
    email: 'kavya.reddy@example.com',
    role: 'Admin',
    status: 'Inactive',
  },
  {
    id: '4',
    name: 'Rohan Singh',
    email: 'rohan.singh@example.com',
    role: 'Admin',
    status: 'Active',
  },
  {
    id: '5',
    name: 'Ishita Mehta',
    email: 'ishita.mehta@example.com',
    role: 'User',
    status: 'Inactive',
  },
  {
    id: '6',
    name: 'Ananya Pillai',
    email: 'ananya.pillai@example.com',
    role: 'Admin',
    status: 'Active',
  },
  {
    id: '7',
    name: 'Vikram Desai',
    email: 'vikram.desai@example.com',
    role: 'User',
    status: 'Active',
  },
];

export const mockRoles = [
  {
    id: '1',
    name: 'Admin',
    permissions: ['read', 'write', 'delete'],
  },
  {
    id: '2',
    name: 'User',
    permissions: ['read'],
  },
]